// extracted by mini-css-extract-plugin
export default {"section":"MainSectionLayout_section__--JVC"};